module.exports = __webpack_public_path__ + "static/img/MAG5.3568d276.jpg";